import * as React from 'react'
import styled from 'styled-components'
import { theme } from 'utils/styledHelper'

type PropsType = {
  children?: React.ReactNode
  height?: string
  toggled?: boolean
  width?: string
}

const Wrapper = styled.div<PropsType>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: ${(p) => p.width};
  min-height: ${(p) => p.height};
  border-bottom: 0.125rem solid ${theme('tabMenuBorderColor')};
  box-sizing: border-box;
`
const Container = styled.div<PropsType>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: space-between;
  width: 100%;
  min-height: 100%;
  @media (max-width: ${(p) => p.theme.screenSizes.sm}) {
    & > .disabled {
      display: ${(props) => (props.toggled === true ? 'flex' : 'none')};
    }
  }
  @media (min-width: ${(p) => p.theme.screenSizes.sm}) {
    flex-direction: row;
    align-items: center;
  }
`

const TabMenu = ({
  children,
  height = '3rem',
  toggled = false,
  width = '100%',
  ...rest
}: PropsType) => (
  <Wrapper height={height} width={width} {...rest}>
    <Container toggled={toggled}>{children}</Container>
  </Wrapper>
)

export default TabMenu
